import {useBulkUploadContext} from "../../BulkUploadContext/BulkUploadContext";
import {Modal} from "@cjdev-internal/visual-stack-x/Modal";
import {SUMMARY_POPUP_CONTACT_SUPPORT_MESSAGE} from "../BulkUploadConstant";
import {Text} from "@cjdev-internal/visual-stack-x/Text";
import {Box} from "@cjdev-internal/visual-stack-x/Box";

const SavePlacementSummary = ({closeModal}) => {
    const {bulkUploadDetails, setBulkUploadDetails} = useBulkUploadContext();
    const closeSavePlacementSummary = () => {
        setBulkUploadDetails((prevState) => ({
            rows: prevState.failedRows,
            successfulRows: [],
            failedRows: []
        }));
        closeModal();
    }
    const modalProps = {
        headerTitle: <>{bulkUploadDetails.failedRows.length} placements failed to upload</>,
        onCloseIconClick: closeSavePlacementSummary,
        height: "205px",
        minHeight: "205px",
        width: "465px"
    }
    return (
        <Modal {...modalProps}>
            <Box gap={'large'}>
                <Box>
                    <Text size={13}>
                        {bulkUploadDetails.successfulRows.length} of {bulkUploadDetails.rows.length} uploaded
                        successfully.
                    </Text>
                    <Text size={13}>
                        {bulkUploadDetails.failedRows.length} of {bulkUploadDetails.rows.length} failed to upload.
                    </Text>
                </Box>
                <Text size={13} color="subdued">{SUMMARY_POPUP_CONTACT_SUPPORT_MESSAGE}</Text>
            </Box>
        </Modal>
    )
}
export default SavePlacementSummary;